import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import App from '../App'
import { PrivilegedAgentRedirect } from '../components/PrivilegedAgentRedirect'
import { AuthProvider } from '../context/AuthContext'
import AnalyticsPage from '../pages/AnalyticsPage'
import ChatHomePage from '../pages/ChatHomePage'
import ChatPage from '../pages/ChatPage'
import EditAgentPage from '../pages/EditAgentPage'
import FeatureFlagsPage from '../pages/FeatureFlagsPage'
import LibraryPage from '../pages/LibraryPage'
import SettingsPage from '../pages/SettingsPage'
import { Feature } from '../core/client/features.gen'
import { FeatureRoute } from '../routes/FeatureRoute'
import ProtectedRoute from '../routes/ProtectedRoute'
import ReshapedAdminRoute from '../routes/ReshapedAdminRoute'
import SuperuserRoute from '../routes/SuperuserRoute'

const AppRoutes = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <App>
          <Routes>

            {/* Root route - redirect to privileged agent */}
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <PrivilegedAgentRedirect />
                </ProtectedRoute>
              }
            />

            {/* Settings Page */}
            <Route
              path="/settings"
              element={
                <ProtectedRoute>
                  <SettingsPage />
                </ProtectedRoute>
              }
            />

            {/* Analytics dashboard (superuser only, behind the analytics feature) */}
            <Route
              path="/analytics"
              element={
                <ProtectedRoute>
                  <FeatureRoute feature={Feature.ANALYTICS}>
                    <SuperuserRoute>
                      <AnalyticsPage />
                    </SuperuserRoute>
                  </FeatureRoute>
                </ProtectedRoute>
              }
            />

            {/* Runtime feature flags (reshaped admins only) */}
            <Route
              path="/admin/features"
              element={
                <ProtectedRoute>
                  <ReshapedAdminRoute>
                    <FeatureFlagsPage />
                  </ReshapedAdminRoute>
                </ProtectedRoute>
              }
            />

            {/* Assistant library (behind the agents feature) */}
            <Route
              path="/library"
              element={
                <ProtectedRoute>
                  <FeatureRoute feature={Feature.AGENTS}>
                    <LibraryPage />
                  </FeatureRoute>
                </ProtectedRoute>
              }
            />

            {/* Edit an assistant (superuser only, behind the agents feature) */}
            <Route
              path="/library/a/:id"
              element={
                <ProtectedRoute>
                  <FeatureRoute feature={Feature.AGENTS}>
                    <SuperuserRoute>
                      <EditAgentPage />
                    </SuperuserRoute>
                  </FeatureRoute>
                </ProtectedRoute>
              }
            />

            {/* Agent-specific home page */}
            <Route
              path="/a/:agentId"
              element={
                <ProtectedRoute>
                  <ChatHomePage />
                </ProtectedRoute>
              }
            />

            {/* Chat Detail Page (legacy route for backward compatibility) */}
            <Route
              path="/c/:chatId"
              element={
                <ProtectedRoute>
                  <ChatPage />
                </ProtectedRoute>
              }
            />

            {/* Agent-specific chat page */}
            <Route
              path="/a/:agentId/c/:chatId"
              element={
                <ProtectedRoute>
                  <ChatPage />
                </ProtectedRoute>
              }
            />

            {/* Fallback redirect */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </App>
      </AuthProvider>
    </BrowserRouter>
  )
}

export default AppRoutes
